module.exports = __webpack_public_path__ + "img/tq2-new2.6695534e.png";